import { Component, inject } from '@angular/core';
import { LoadingSpinnerService } from './services/loading-spinner.service';
import { Observable } from 'rxjs';
import { IconService } from './services/icon.service';
import { IframeEventsService } from './services/iframe-events.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  private readonly loadingSpinnerService = inject(LoadingSpinnerService);
  private readonly iconService = inject(IconService);
  private readonly iframeService = inject(IframeEventsService);

  get loadingState$(): Observable<boolean> {
    return this.loadingSpinnerService.loadingState$;
  }

  constructor() {
    this.iconService.registerIcons();
  }
}
